module.exports = __webpack_public_path__ + "static/media/logos_squares_ORG_EMSD.9b3a42ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_ORG_EMSD.png
// module id = 35
// module chunks = 0